export default __webpack_public_path__ + "static/media/Nikita.7e93d792.jpg";